<template>
    <div>
        <div class="contents">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="breadcrumb-main user-member justify-content-sm-between ">
                            <div class=" d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                                <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                    <h4 class="text-capitalize fw-500 breadcrumb-title">Detail Message Template</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div v-if="!isLoading" class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <form v-on:submit.prevent="editMessageTemplate">
                                <label>Title</label>
                                <input type="text" class="form-control" v-model="form.title" readonly />

                                <!-- WA section -->
                                <h5 class="mt-4 mb-2"><i class="fab fa-whatsapp text-success"></i> Pesan WhatsApp</h5>
                                <label>Message (WhatsApp)</label>
                                <textarea cols="30" class="form-control" rows="8" v-model="form.message" placeholder="Pesan untuk WhatsApp"></textarea>

                                <hr class="my-4">

                                <!-- Email section -->
                                <h5 class="mt-3 mb-2"><i class="fas fa-envelope text-primary"></i> Pesan Email (auto-forward)</h5>
                                <div class="alert alert-info" style="font-size:13px;">
                                    💡 Setiap kali notifikasi WA ini di-trigger, sistem otomatis kirim email juga ke user dan copy ke <code>{{ ccEmail }}</code> (admin platform).
                                    Kalau Email Subject & Body dikosongkan, sistem akan auto-generate dari pesan WA.
                                </div>

                                <div class="custom-control custom-switch mb-3">
                                    <input type="checkbox" class="custom-control-input" id="forwardToggle"
                                        :checked="forwardToEmailBool" @change="forwardToEmailBool = $event.target.checked">
                                    <label class="custom-control-label" for="forwardToggle">
                                        <strong>Aktifkan auto-forward ke email</strong>
                                        <small class="d-block text-muted">Kalau dimatikan, notif ini cuma kirim WA tanpa email</small>
                                    </label>
                                </div>

                                <label>Email Subject (opsional)</label>
                                <input type="text" class="form-control" v-model="form.email_subject"
                                    placeholder="Default: [StarSender] {Event Type}" maxlength="255">
                                <small class="text-muted">Support placeholder seperti {name}, {username}, {package}, dll</small>

                                <label class="mt-3">Email Body / HTML (opsional)</label>
                                <textarea cols="30" class="form-control" rows="12" v-model="form.email_body"
                                    placeholder="HTML email body. Kosongkan untuk auto-generate dari pesan WA dengan wrapper template StarSender."></textarea>
                                <small class="text-muted">Support HTML lengkap. Placeholder sama dengan pesan WA.</small>

                                <div class="button-group d-flex pt-25">
                                    <button type="submit"
                                        class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                                        <i class="fas fa-save"></i> Simpan
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div v-else class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <center>
                                <div class="spinner-border spinner" role="status"></div>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                id: '',
                form: {},
                packages: [],
                isLoading: true,
                ccEmail: 'starfield.id@gmail.com',
            };
        },
        computed: {
            forwardToEmailBool: {
                get() { return this.form.forward_to_email === null || this.form.forward_to_email === undefined ? true : this.form.forward_to_email === 1; },
                set(v) { this.$set(this.form, 'forward_to_email', v ? 1 : 0); }
            }
        },
        async mounted() {
            await this.loadData()
            this.id = this.$route.query.id
        },
        methods: {
            async editMessageTemplate() {
                try {
                    const payload = {
                        id: this.form.id,
                        message: this.form.message || '',
                        email_subject: this.form.email_subject || null,
                        email_body: this.form.email_body || null,
                        forward_to_email: this.form.forward_to_email !== undefined ? this.form.forward_to_email : 1,
                    };
                    let response = await this.$store.dispatch('admin_message_template_update', payload);
                    this.$toast.success(response.data.message);
                    await this.loadData();
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || 'Gagal update template');
                }
            },
            async loadData() {
                try {
                    let id = this.$route.query.id;
                    let detail = await this.$store.dispatch("admin_message_template_detail", { id: id });
                    this.form = detail.data.data.template_message;
                    this.isLoading = false;
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || 'Gagal load');
                    this.$router.push("/admin/message-template");
                }
            },
        },
    };
</script>

<style scoped>
label { font-weight: 600; margin-top: 8px; display: block; }
.custom-switch { margin-top: 8px; }
</style>
